import { render, staticRenderFns } from "./exames.vue?vue&type=template&id=21051006&scoped=true"
import script from "./exames.vue?vue&type=script&lang=js"
export * from "./exames.vue?vue&type=script&lang=js"
import style0 from "./exames.vue?vue&type=style&index=0&id=21051006&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21051006",
  null
  
)

export default component.exports